import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { api } from '../services/api';
import {
  ProfitChartApiResponse,
  SubscriptionProfitChartApiResponse,
} from '../../screens/Detail/Charts/types';

interface ChartDataState {
  data: Record<number, ProfitChartApiResponse>;
}

const initialState: ChartDataState = {
  data: {},
};

const chartDataSlice = createSlice({
  name: 'chartData',
  initialState,
  reducers: {
    hydrateChartData: (
      state,
      action: PayloadAction<Record<number, SubscriptionProfitChartApiResponse>>,
    ) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      api.endpoints.getSubscriptionDetails.matchFulfilled,
      (state, { payload }) => {
        if (payload.chartData) {
          state.data[payload.id] = payload.chartData;
        }
      },
    );
  },
});

export const { hydrateChartData } = chartDataSlice.actions;

export const selectChartData = (subscriptionId: number) => (state: RootState) =>
  state.chartData.data[subscriptionId];

export const selectAllChartData = (state: RootState) => state.chartData.data;

export default chartDataSlice.reducer;
